import { render, staticRenderFns } from "./PolygonShape.vue?vue&type=template&id=22980448&scoped=true"
import script from "./PolygonShape.vue?vue&type=script&lang=js"
export * from "./PolygonShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22980448",
  null
  
)

export default component.exports